import { StyleRules } from '@material-ui/core/styles';
import { AutocompleteClassKey } from '@material-ui/lab';

import { core as theme } from '../styles/core';

export const MuiAutocomplete: Partial<StyleRules<AutocompleteClassKey>> = {
  root: {
    '&.Mui-focused .MuiOutlinedInput-root': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    ...theme.typography.body2,
  },
  paper: {
    padding: 0,
    marginTop: -1,
    border: 'solid',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 1,
    borderColor: theme.palette.primary.main,
  },
  listbox: {
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
  option: {
    ...theme.typography.body2,
  },
  tag: {
    margin: theme.spacing(0),
  },
};
